import { useTranslation } from "react-i18next";

interface MobileTagChipProps {
  name: string;
  color?: string | null;
  selected?: boolean;
  onClick?: () => void;
  onRemove?: () => void;
  disabled?: boolean;
}

const DEFAULT_COLOR = "#3B82F6";

/**
 * Chip de tag do app mobile. Sem `onClick` vira um badge estático (lista de
 * conversas); com `onClick` vira um alvo de toque para (des)marcar a tag.
 */
export const MobileTagChip = ({
  name,
  color,
  selected = true,
  onClick,
  onRemove,
  disabled,
}: MobileTagChipProps) => {
  const { t } = useTranslation();
  const tone = color || DEFAULT_COLOR;
  const style = selected
    ? { backgroundColor: `${tone}24`, color: tone, borderColor: `${tone}59` }
    : undefined;

  const className = `inline-flex max-w-full items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium capitalize leading-[18px] transition-colors ${
    selected ? "" : "border-border bg-transparent text-muted-foreground"
  } ${onClick ? "active:opacity-70" : ""} ${disabled ? "opacity-50" : ""}`;

  const content = <span className="truncate">{name}</span>;

  if (onClick) {
    return (
      <button type="button" onClick={onClick} disabled={disabled} className={className} style={style}>
        {content}
      </button>
    );
  }

  return (
    <span className={className} style={style}>
      {content}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          disabled={disabled}
          aria-label={t('common:shared.removeTag', { name })}
          className="-mr-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full active:bg-black/10"
        >
          <svg width="9" height="9" viewBox="0 0 10 10" fill="none" aria-hidden="true">
            <path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
      )}
    </span>
  );
};
